import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {SecureXhrDownloadPipe} from './blob-image-pipe';
import {LicenceKeyReadablityPipe} from './licence-key-readablity.pipe';
import {SizeStringToBoolPipe} from './size-string-to-bool-pipe';
import {FormatIbanPipe} from './format-iban-pipe';
import {RoleIncludesPipe} from './role-includes.pipe';
import {LocalizedDatePipe} from './localized-date-pipe';
import {TypeToIconPipe} from './type-to-icon.pipe';
import {DdMmYyyyDatePipe} from './dd-mm-yyyy-date.pipe';
import {ReplaceSpacePipe} from './replace-space-pipe';
import {OpeningTimePipe} from './opening-time.pipe';
import {YascPipeKeyValue} from './enum-convert-pipe';
import {AsPipePipe} from './as-pipe.pipe';

const PIPES = [
    AsPipePipe,
    SecureXhrDownloadPipe,
    LicenceKeyReadablityPipe,
    TypeToIconPipe,
    SizeStringToBoolPipe,
    OpeningTimePipe,
    FormatIbanPipe,
    ReplaceSpacePipe,
    DdMmYyyyDatePipe,
    LocalizedDatePipe,
    RoleIncludesPipe,
    YascPipeKeyValue,
]

@NgModule({
    declarations: [
        ...PIPES,
    ],
    imports: [
        DatePipe,
        CommonModule,
    ],
    exports: [
        ...PIPES,
    ],
    providers: [
        LocalizedDatePipe
    ]
})
export class PipesModule {
}
